import React, { useState } from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { DOCK_TAB_HELP, DockHelpId } from './tabHelpCopy';

const GOLD = '#f5b942';
const MUTED = '#8a939f';
const SURFACE = '#1b1e26';
const EDGE = 'rgba(255,255,255,0.13)';

export const DockTabHelp: React.FC<{ tab: DockHelpId }> = ({ tab }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const help = DOCK_TAB_HELP[tab];

  return (
    <>
      <IconButton
        size="small"
        aria-label={`About ${help.title}`}
        aria-expanded={!!anchor}
        onClick={(e) => {
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        sx={{
          p: 0.25,
          color: MUTED,
          '&:hover': { color: GOLD, bgcolor: 'rgba(245,185,66,0.08)' },
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 15 }} />
      </IconButton>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: {
              mt: 0.5,
              maxWidth: 340,
              maxHeight: 420,
              overflow: 'auto',
              bgcolor: SURFACE,
              color: '#e9ecf2',
              border: `1px solid ${EDGE}`,
              boxShadow: '0 8px 28px rgba(0,0,0,0.45)',
            },
          },
        }}
      >
        <Box sx={{ px: 1.5, pt: 1.25, pb: 1.4 }}>
          <Typography
            sx={{
              fontSize: '0.62rem',
              fontWeight: 800,
              letterSpacing: 0.8,
              textTransform: 'uppercase',
              color: GOLD,
              mb: 0.6,
            }}
          >
            {help.title}
          </Typography>
          <Typography sx={{ fontSize: '0.72rem', lineHeight: 1.5, color: '#e9ecf2' }}>
            {help.lead}
          </Typography>
          {help.items?.map((item) => (
            <Box key={item.label} sx={{ mt: 1 }}>
              <Typography
                sx={{
                  fontSize: '0.62rem',
                  fontWeight: 800,
                  letterSpacing: 0.4,
                  color: GOLD,
                  mb: 0.2,
                }}
              >
                {item.label}
              </Typography>
              <Typography sx={{ fontSize: '0.7rem', lineHeight: 1.45, color: '#c5cbd4' }}>
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default DockTabHelp;
